import { ItemPrice } from '@web/utils';
import { CartButton } from '@/components/Cart';
import { Article } from '@/types';

interface CaroyselItemProps {
  article: Article;
}

const CarouselItem = (props: CaroyselItemProps) => {
  const { article } = props;

  return (
    <div className="flex justify-between my-1-0 gap-4-0 p-3-0 md:p-2-0 w-full rounded-10-0 shadow-md">
      <div>
        <p className="title font-bd text-2-6 md:text-1-4 leading-1-33 md:leading-body1 min-h-[3rem] line-clamp-2">
          {article.name}
        </p>
        <p className="font-rg text-2-0 md:text-1-2 leading-body1">
          {article.subtitle}
        </p>
      </div>
      <ItemPrice article={article} className="transform scale-90" />
      <div className="min-w-[4rem]">
        <CartButton disableCount article={article} />
      </div>
    </div>
  );
};

export default CarouselItem;
